
<!-- Template for the auth content -->
<ng-template #authContent>
    <div style="max-width: 700px; margin: auto;">
        <!-- <div class="background-sky hero"></div> -->

        <div style="height: 10vh" *ngIf="!isLoginModal"></div>
        <div style="height: 5vh"></div>
        <div style="text-align: center;">
            <img style="max-height: 35px;" [src]="logo" alt="">
        </div>
        <div style="height: 5vh"></div>

        

        <app-login *ngIf="login"></app-login>
        <app-signup *ngIf="signup"></app-signup>
        <app-verify *ngIf="verify" [phone]="phone" [countryCode]="countryCode"></app-verify>
        <app-forgot-password *ngIf="forgotPassword" [isOldLoginModal]="isLoginModal"></app-forgot-password>

        <div *ngIf="login" class="ion-text-center">
            <a (click)="doSignup()">{{'DONT_HAVE_AN_ACCOUNT_YET' | translate}}<br />{{'SIGN_UP_IT_FREE' | translate}}</a>
            <br><br>
            <a (click)="doForgotPassword()">{{'Forgot password' | translate}}?</a>
        </div>

        <div *ngIf="signup" class="ion-text-center">
            <a (click)="doVerify()">{{'Already have a code? Verify.' | translate}}</a>
            <br><br>
            <a (click)="doLogin()">{{'BACK' | translate}}</a>
        </div>

        <div *ngIf="verify" class="ion-text-center">
            <a (click)="doSignup()">{{'BACK' | translate}}</a>
        </div>

        <div *ngIf="forgotPassword" class="ion-text-center">
            <a (click)="doLogin()">Back</a>
        </div>
    </div>
</ng-template>

@if(!isLoginModal ){
<ion-content #content scroll-y="true">
    <ng-container *ngTemplateOutlet="authContent"></ng-container>
</ion-content>
}

@if(isLoginModal && isNewUIFlow){
    <app-auth-private [isLoginModal]="isLoginModal"></app-auth-private>
}

@if(isLoginModal && !isNewUIFlow){
    <ion-header class="ion-no-border"*ngIf="isLoginModal">
        <ion-toolbar>
            <ion-title *ngIf="isLoginModal"> {{ 'Login' | translate }}</ion-title>
            <ion-buttons *ngIf="isLoginModal" slot="end">
                <ion-button (click)="close()" color="light">
                    <ion-icon slot="icon-only" class="close" name="close"></ion-icon>
                </ion-button>
            </ion-buttons>
        </ion-toolbar>
    </ion-header>
    <ion-content #content scroll-y="true">
        <ng-container *ngTemplateOutlet="authContent"></ng-container>
    </ion-content>
}